import { Component, inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { UiKitModule } from "@app/ui-kit.module";
import { AreaHeaderComponent } from "@odx/angular/components/area-header";
import { ButtonComponent } from "@odx/angular/components/button";
import { ModalRef } from "@odx/angular/components/modal";

interface CreateGroupModalData {
  nextGroupId: number;
}

@Component({
  selector: "app-create-group-modal",
  imports: [UiKitModule, AreaHeaderComponent, ButtonComponent, ReactiveFormsModule],
  templateUrl: "./create-group-modal.component.html",
})
export class CreateGroupModalComponent implements OnInit {
  public readonly modalRef = inject(ModalRef<CreateGroupModalData>);
  protected groupNameForm!: FormGroup;
  private formBuilder = inject(FormBuilder);

  private groupId!: number;

  ngOnInit(): void {
    this.groupId = this.modalRef.data.nextGroupId;
    this.groupNameForm = this.formBuilder.group({
      name: [this.createInitialGroupName(), [Validators.required, Validators.maxLength(50)]],
    });
  }

  onConfirm() {
    this.modalRef.close({ groupName: this.groupNameForm.value.name, groupId: this.groupId });
  }

  private createInitialGroupName() {
    return $localize`:@@floorplan.details.form.group.defaultName:Gruppe ${this.groupId}`;
  }
}
